import { sendButton } from 'icons/send.js';
import { Calendar } from 'ui/calendar/calendar.module';

import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { Button } from 'components/UI/button/button.module';
import FormInput from 'components/UI/FormInput/formInput.module';
import { RUD_COUNTRY_CODES } from 'consts/consts';
import { BUTTON_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import {
	callbackOnKeyDown,
	generate6DigitUUID,
	hasClass,
	onEditResponse,
	readFromLs,
	setCustomTagHTML,
	writeToLs,
} from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

import { addClass } from '../../../helpers/helpers';
import { clearRudInputArea, rudonClick } from './helpers/helpers';
import { RudTemplate } from './rud.template';

export default class Rud {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = {};
		this.setter(propData);
		this.data.id = propData.id || propData.message_id || `message-${generate6DigitUUID()}`;
		if (!this.data.error && !ENGT_CHAT.get('config.isOldMessage')) {
			writeToLs(LS().RUD_NODE, this.data.id);
		}
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-msg engt-msg-bot engt-msg-border-bot engt-rud-node';
		wrapper.innerHTML = RudTemplate({ ...this.data, replyInput: ENGT_CHAT.get('config.isRudRespondBoxEnabled') });
		this.html = new MessageWrapper({
			...this.data,
			message: this.data?.message?.text || 'Request User Data',
			innerHTML: wrapper.outerHTML,
		});
	}

	renderEditBtn() {
		const editBtn = this.html.querySelector(`#editBtn-${this.data.id}`);
		editBtn.style.display = 'block';
	}

	getInputType(rcvInpFlag) {
		let inputType = '';
		switch (rcvInpFlag) {
			case 'password':
				inputType = 'password';
				break;
			case 'date':
				inputType = 'date';
				break;
			case 'email':
				inputType = 'email';
				break;
			default:
				inputType = 'text';
				break;
		}
		return inputType;
	}

	appendInputBox(inpType, className = '') {
		const { message, message_id, id, rud_display_settings, isOldMessage } = this.data;
		const inputProps = {
			attribute_type: inpType,
			attribute_id: `rud-input-${readFromLs(LS().RUD_NODE)}`,
			display_name: message?.text,
			message_id,
			placeholder: ENGT_CHAT.get('GENERIC_STRINGS')?.['PLACEHOLDER.FILL_DETAILS'] || 'Please fill in this field',
			style: 'margin-top: 0px; width: 100%;',
			inpClassName: className,
		};
		const ref = this;
		function reorderCountryCodes(customCountryCodes) {
			const reorderedCountryCodes = {};
			customCountryCodes.forEach((code) => {
				if (RUD_COUNTRY_CODES[code]) {
					reorderedCountryCodes[code] = RUD_COUNTRY_CODES[code];
				}
			});
			Object.keys(RUD_COUNTRY_CODES).forEach((code) => {
				if (!customCountryCodes.includes(code)) {
					reorderedCountryCodes[code] = RUD_COUNTRY_CODES[code];
				}
			});

			return reorderedCountryCodes;
		}

		if (rud_display_settings && !isOldMessage) {
			const rudDisplaySettings = JSON.parse(rud_display_settings);
			if (rudDisplaySettings?.show_country_code && !ENGT_CHAT.get('config.isRudRespondBoxEnabled')) {
				inputProps.inputWithSelect = true;
				const countryCodes = Array.isArray(ENGT_CHAT.get('config.customCountryCodes'))
					? reorderCountryCodes(ENGT_CHAT.get('config.customCountryCodes'))
					: RUD_COUNTRY_CODES;
				inputProps.selectOptions = JSON.stringify(countryCodes);
				inputProps.overrideOptionsClass = 'engt-override-dropdowns';
			} else if (rudDisplaySettings?.show_text_area) {
				inputProps.renderAsTextArea = true;
			}
		}
		if (ENGT_CHAT.get('config.isRudRespondBoxEnabled')) {
			const rudInputArea = document.querySelector('rud-input-area');
			const existingInput = rudInputArea.querySelector('.rud-input-field');

			if (existingInput) {
				existingInput.remove();
			}

			const divElement = document.createElement('div');
			divElement.classList.add('rud-input-field');

			const wrapperElement = document.createElement('div');
			wrapperElement.classList.add('rud-wrapper');
			wrapperElement.style.background = ENGT_CHAT.get('config.textAreaColor');

			const rudResponseInput = new FormInput({
				...inputProps,
				includeLabel: !ENGT_CHAT.get('config.isRudRespondBoxEnabled'),
			}).render();

			const rudInputBox = rudResponseInput.querySelector('input');

			wrapperElement.appendChild(rudResponseInput);

			const attribute_id = `${id}`;
			const rudErrorMsg = document.createElement('rud-error-msg');
			rudErrorMsg.id = `engt-error-${attribute_id}`;

			const errorMsgElement = divElement.querySelector('error-msg');
			if (errorMsgElement) {
				errorMsgElement.remove();
			}

			const sendButtonElement = document.createElement('button');
			sendButtonElement.id = 'engtRudSendBtn';
			sendButtonElement.className = 'engt-btn-icons engt-tab-selectable engt-reply-btns';
			sendButtonElement.setAttribute('aria-label', 'Send RUD Message');
			sendButtonElement.innerHTML = `${sendButton()}`;

			wrapperElement.appendChild(sendButtonElement);

			divElement.appendChild(wrapperElement);
			divElement.appendChild(rudErrorMsg);

			rudInputArea.appendChild(divElement);

			rudResponseInput.addEventListener('keypress', (event) => {
				if (event.keyCode === 13 || event.key === 'Enter') {
					rudonClick.call(ref, id, message_id, message.rcv_inp_type_flag);
				}
			});

			sendButtonElement.addEventListener('click', () => {
				rudonClick.call(ref, id, message_id, message.rcv_inp_type_flag);
			});

			const formInput = new FormInput({
				...inputProps,
				includeInput: !ENGT_CHAT.get('config.isRudRespondBoxEnabled'),
			}).render();
			setCustomTagHTML(this.html.querySelector('form-input'), formInput);

			if (rudInputBox) {
				rudInputBox.classList.add('rud-box-input');
			}

			const inputElement = divElement.querySelector('.engt-form-input-text');

			if (inputElement) {
				inputElement.style.border = 'none';
				inputElement.style.borderRadius = '1rem';
			}
		} else {
			const formInput = new FormInput(inputProps).render();
			setCustomTagHTML(this.html.querySelector('form-input'), formInput);
		}
	}

	appendConfirmButton(inpType) {
		const { id, message_id, data_tracking_id = '', message, user_id } = this.data;
		const ref = this;
		const confirmBtn = !this.data.isOldMessage
			? new Button({
					type: BUTTON_TYPE.PRIMARY,
					label: ENGT_CHAT.get('GENERIC_STRINGS')?.['SUBMIT'] || 'Submit',
					id: `confirmBtn-${id}`,
					radius: 18,
					style: 'margin-top: 20px;',
					applyOnHover: true,
					dataInteractiveField: true,
					dataTrackingId: data_tracking_id || '',
					onClick() {
						const textField = ref.html.querySelector(`#rud-input-${id}`);
						const datepicker = ref.html.querySelector(`#engtDatePicker-${id}`);
						let text = datepicker ? datepicker.getAttribute('data-selected-date') : textField?.value;
						const err = document.getElementById(`rud-error-${readFromLs(LS().RUD_NODE)}`);

						if (err) {
							addClass(err, 'engt-hidden');
						}
						if (ref.data?.rud_display_settings) {
							const rudDisplaySettings = JSON.parse(ref.data.rud_display_settings);
							if (
								rudDisplaySettings?.show_country_code &&
								!ENGT_CHAT.get('config.isRudRespondBoxEnabled')
							) {
								const inputField = ref.html.querySelector(`#rud-input-${id}.engt-form-input-text`);
								text = `${text}-${inputField?.value}`;
							}
						}
						if (text?.trim()) {
							ENGT_CHAT.get('sendMessage')(text.trim(), {
								skipAppendToDom: true,
								message_id,
							});
							this.disabled = true;
							if (textField) {
								textField.disabled = true;
							}
							this.classList.add('engt-rud-disabled');
						}
					},
			  }).render()
			: '';
		if (inpType !== 'date') {
			if (confirmBtn) {
				confirmBtn.disabled = true;
				confirmBtn.classList.add('engt-rud-disabled');
			}
		}
		setCustomTagHTML(this.html.querySelector('confirm-btn'), confirmBtn);
	}

	initComponents() {
		const { message, validated, isOldMessage } = this.data;

		const inpType = this.getInputType(message.rcv_inp_type_flag);

		if (validated) {
			const msg = document.createElement('strong');
			msg.style.width = '100%';
			msg.innerHTML = validated;
			setCustomTagHTML(this.html.querySelector('validated-msg'), msg);
			if (
				ENGT_CHAT.get('config.isOldMessage') &&
				!document.getElementById(`confirmBtn-${readFromLs(LS().RUD_NODE)}`)
			) {
				this.appendInputBox(inpType, 'engt-hidden');
				clearRudInputArea();
			}
			if (
				!document.getElementById(`confirmBtn-${readFromLs(LS().RUD_NODE)}`) &&
				!ENGT_CHAT.get('config.isOldMessage')
			) {
				localStorage.removeItem(LS().RUD_NODE);
			}
			return;
		}
		if (inpType === 'date' && !isOldMessage) {
			const pickerContainer = new Calendar({
				id: `engtDatePicker-${readFromLs(LS().RUD_NODE)}`,
				errorId: `rud-error-${readFromLs(LS().RUD_NODE)}`,
				label: message?.text,
			});
			this.html
				.querySelector('.engt-rud-node')
				.insertBefore(pickerContainer.render(), this.html.querySelector('.engt-rud-node').firstChild);
		} else {
			this.appendInputBox(inpType);
		}
		this.appendConfirmButton(inpType);

		if (ENGT_CHAT.get('config.edit_user_input') && !isOldMessage) {
			const ref = this;
			const editButton = new Button({
				type: BUTTON_TYPE.MINI,
				label: ENGT_CHAT.get('config.default_edit_response')
					? ENGT_CHAT.get('config.default_edit_response')
					: ENGT_CHAT.get('GENERIC_STRINGS')?.['EDIT'] || 'Edit',
				id: `editBtn-${this.data.id}`,
				style: 'display:none;',
				applyOnHover: true,
				onClick() {
					const flowKey = ref.data.flow_key;
					const nodeKey = ref.data.node_key;
					if (flowKey && nodeKey) {
						this.style.display = 'none';
						onEditResponse(flowKey, nodeKey);
						ENGT_CHAT.set('editFlowId', '');
					} else console.error('flow key and and node key are not set and hence not triggering edit flow');
				},
				radius: 18,
			}).render();

			setCustomTagHTML(this.html.querySelector('edit-btn'), editButton);
			ENGT_CHAT.set('editFlowId', `editBtn-${this.data.id}`);
		} else {
			setCustomTagHTML(this.html.querySelector('edit-btn'), '');
		}
	}

	initEventHandlers() {
		const { rud_display_settings } = this.data;
		let querySelector = `#rud-input-${readFromLs(LS().RUD_NODE)}`;
		if (rud_display_settings) {
			const rudDisplaySettings = JSON.parse(rud_display_settings);
			if (rudDisplaySettings?.show_country_code && !ENGT_CHAT.get('config.isRudRespondBoxEnabled')) {
				querySelector += '.engt-form-input-text';
			}
		}

		const inputField = this.html.querySelector(querySelector);
		inputField?.addEventListener('input', () => {
			const err = document.getElementById(`rud-error-${readFromLs(LS().RUD_NODE)}`);
			const confirmBtn = this.html.querySelector(`#confirmBtn-${readFromLs(LS().RUD_NODE)}`);
			if (err) {
				err.classList.add('engt-hidden');
				inputField.classList.remove('engt-error-input');
			}
			if (confirmBtn) {
				if (inputField?.value && inputField.value.trim()) {
					if (hasClass(confirmBtn, 'engt-rud-disabled')) {
						confirmBtn.disabled = false;
						confirmBtn.classList.remove('engt-rud-disabled');
					}
				} else if (!hasClass(confirmBtn, 'engt-rud-disabled')) {
					confirmBtn.disabled = true;
					confirmBtn.classList.add('engt-rud-disabled');
				}
			}
		});
		inputField?.addEventListener('keydown', (event) => {
			const confirmBtn = this.html.querySelector(`#confirmBtn-${readFromLs(LS().RUD_NODE)}`);
			callbackOnKeyDown(() => confirmBtn?.click());
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
